var DescriptionsItem = function DescriptionsItem(_ref) {
  var children = _ref.children;
  return children;
};
export default DescriptionsItem;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/descriptions/Item.js
// module id = 2249
// module chunks = 1